import type { TripFolderBooking } from '../../../lib/types/models/trip-folder/trip-folder'
import type { TripFolderPassengersFilters } from '../../../lib/types/models/trip-folder/trip-folder-passengers'

export const flattenTripFolderBookings = (
  tripFolderBookings: TripFolderBooking[]
): TripFolderBooking[] =>
  tripFolderBookings.flatMap((tripFolderBooking) => [
    tripFolderBooking,
    ...(tripFolderBooking.secondaryReservation
      ? flattenTripFolderBookings([tripFolderBooking.secondaryReservation])
      : [])
  ])

export const checkIsSplittingDisabled = (selectedFilters: TripFolderPassengersFilters) => {
  const tripBookingIds = selectedFilters?.tripBookingIds ?? []
  const centerIds = selectedFilters?.centerIds ?? []

  const hasMultipleTripBookings = tripBookingIds.length > 1
  const hasMultipleCenters = centerIds.length > 1

  const hasTripBookingFilter = tripBookingIds.length > 0
  const hasCenterFilter = centerIds.length > 0
  const hasOtherFilters = Object.entries(selectedFilters ?? {}).some(
    ([key, value]) => key !== 'tripBookingIds' && key !== 'centerIds' && (value ?? []).length > 0
  )

  const disableSplitting =
    !selectedFilters ||
    hasOtherFilters || // Disable if any other filter type is active
    (hasTripBookingFilter && hasCenterFilter) || // Disable if both allowed filters are active
    (!hasTripBookingFilter && !hasCenterFilter) || // Disable if no allowed filters are active
    hasMultipleTripBookings || // Disable if more than one trip booking is selected
    hasMultipleCenters // Disable if more than one center is selected

  return disableSplitting
}
